<div *ngIf="visible" class="ann-banner" role="status" aria-live="polite">
  <div class="ann-banner__body">
    <img src="assets/icons/whatsapp.svg" width="16" height="16" class="ann-banner__icon" alt="" aria-hidden="true">
    <div class="ann-banner__text">
      <span class="ann-banner__headline">{{ 'LAYOUT.ANNOUNCEMENT_BANNER.HEADLINE' | translate }}</span>
      <span class="ann-banner__sub">
        {{ 'LAYOUT.ANNOUNCEMENT_BANNER.SUB' | translate }}
        <strong>{{ 'LAYOUT.ANNOUNCEMENT_BANNER.SUB_HIGHLIGHT' | translate }}</strong>.
      </span>
    </div>

  </div>
  <button
    type="button"
    class="ann-banner__close"
    [attr.aria-label]="'LAYOUT.ANNOUNCEMENT_BANNER.ARIA_CLOSE' | translate"
    (click)="dismiss()"
  >
    <lucide-icon name="x" [size]="14"></lucide-icon>
  </button>
</div>
